import template from './container.template.html';
import './container.style.scss';

const component = {
	template,
	transclude: true
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/base/components/container/index.js